export function iterateQuerySelectorAll(root, selector, cb)
{
    [].forEach.call(root.querySelectorAll(selector), cb);
}
